module.exports = __webpack_public_path__ + "img/menu-store-2.bf08a4f9.jpg";